import React, { useState } from "react";
import "./LoginScreen.css";
import SingUpScreen from './SingUpScreen';

function Login() {
  const [singIn, setSingIn] = useState(false);


  return (
    <div className="loginscreen">
      <div className="login-bg">
        <img
          className="logingscreen-logo"
          src="https://th.bing.com/th/id/Rfa3636454a1279798bf40b6e6ac994bf?rik=DG9ZKeTH%2bOzOfw&riu=http%3a%2f%2fsteve-lovelace.com%2fwordpress%2fwp-content%2fuploads%2f2013%2f09%2fnetflix-logo-in-optima-font-1024x307.png&ehk=KdlCEfM5oLBxzuuXtCH%2fobBYVZBy5J6%2fBBgSGujlJu8%3d&risl=&pid=ImgRaw"
          alt=""
        />
        <button onClick={() => setSingIn(true)} className="loginscreen-singin-btn">SingIn</button>
        <div className="loginscreen-gradient" />
      </div>
      <div className="loginscreen-body">
        {singIn ? (
          <SingUpScreen />
        ) : (
        <>
        <h1>Unlimited Movies , Series, Tv Program, Animes & More.</h1>
        <p>
          First 100 User can earn <span style={{ color: "green" }}>Free</span>
          <span style={{ color: "brown ", padding: "2px" }}>Gold</span>Pack.
          Register Now. 2021-04-01.
        </p>
        <p>
          Ready To Start ? Enter Your Email To Create Or Restart MemberShip.
        </p>
        <form>
          <input
            className="login-input"
            type="email"
            placeholder="ex:@Gmail.com"
            required
          />
          <button onClick={() => setSingIn(true)} className="loginscreen-getstarted">
            GET STARTED &gt;&gt;
          </button>
          </form>
          </>)}
      </div>
    </div>
  );
}

export default Login;
